import axios from "@util/axios.js";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

// Move all emails from email table in java backend database to messages table before getting mail messages

export const getAttachments = async (mailBoxId, messageId, partId) => {
   return `${hostCloud}/email/message/download-attachment?mailBoxId=${mailBoxId}&messageId=${messageId}&partId=${partId}`;
};

export const getCurrentFolderMessages = async (listId, profile, page, itemsPerPage, filter) => {
   const url = `${hostCloud}/legacy/request`;
   const params = {
      listId,
      pagination: {
         page,
         itemsPerPage,
      },
      ...(profile && { profile }),
      ...(filter && { filter }),
   };
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/lists",
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   });
};

export const checkPinStatus = async (messagesIdList) => {
   return axios({
      method: "POST",
      url: `${hostCloud}/email/message/mails-processed-cases`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         messagesIds: messagesIdList,
      },
   });
};

export const unpinCase = async (mailboxId, messageId, caseIds) => {
   const body = {
      caseIds,
      mailboxId,
      messageId,
   };

   return axios({
      method: "PUT",
      url: `${hostCloud}/email/message/unpin-case`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: JSON.stringify(body),
   });
};

export const sendEmailMessage = async (
   file,
   actionType /* "send" / "forward" / "reply" */,
   previousFilePartIds,
) => {
   let url = `${hostCloud}/email/message/${actionType}`;
   if (previousFilePartIds) {
      url += `/?previousAttachmentsParts=${previousFilePartIds}`;
   }
   return await axios({
      method: "POST",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "multipart/form-data",
      },
      data: file,
   });
};

export const getUserMailboxFolders = async (mailBoxId) => {
   return axios({
      method: "get",
      url: `${hostCloud}/email/message/mailbox-folders?mailBoxId=${mailBoxId}`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const getUserMailsFromFolder = async (mailBoxId, folder, page, messagePerPage) => {
   return axios({
      method: "get",
      url: `${hostCloud}/email/message/mails`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      params: {
         mailBoxId,
         folder,
         page,
         messagePerPage,
      },
   });
};

export const getFilteredUserMailsFromFolder = async (
   mailBoxId,
   folder,
   page,
   messagePerPage,
   filters,
   filterType = "AND",
) => {
   /* Filters:
         -String subject
         -String receivedDate
         -List<String> toAddresses
         -List<String> ccAddresses
         -List<String> bccAddresses
         -String sender
   */
   return axios({
      method: "post",
      url: `${hostCloud}/email/message/mails?page=${page}&messagePerPage=${messagePerPage}&mailBoxId=${mailBoxId}&folder=${folder}`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: { ...filters, filterType: filterType },
   });
};

export const getRefreshedUserMailsFromFolder = async (mailBoxId, folder, page, messagePerPage) => {
   return axios({
      method: "get",
      url: `${hostCloud}/email/message/refresh?page=${page}&messagePerPage=${messagePerPage}&mailBoxId=${mailBoxId}&folder=${folder}`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const getEmailDetails = async (messageId, mailBoxId, cancelToken) => {
   return axios({
      method: "get",
      url: `${hostCloud}/email/message/details?mailBoxId=${mailBoxId}&messageId=${messageId}`,
      headers: {
         Accept: "*/*",
      },
      cancelToken,
   });
};

export const getEmailImages = async (mailBoxId, messageId, imgSrc) => {
   const url = `${hostCloud}/email/message/download-inline`;
   return axios({
      method: "get",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      params: {
         mailBoxId: mailBoxId,
         messageId: messageId,
         imgSrc: imgSrc,
      },
   });
};

export const markMessageRead = async (mailBoxId, messagesIds) => {
   const url = `${hostCloud}/email/message/mark-read`;
   return axios({
      method: "PUT",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      params: {
         mailBoxId: mailBoxId,
         messagesIds: messagesIds,
      },
   });
};

export const moveUserMailsToTrashFolder = async (mailBoxId, messagesIds) => {
   const url = `${hostCloud}/email/message/trash?mailBoxId=${mailBoxId}&messagesIds=${messagesIds}`;
   return axios({
      method: "PUT",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const deleteUserMail = async (mailBoxId, messagesIds) => {
   const url = `${hostCloud}/email/message/trash/delete?mailBoxId=${mailBoxId}&messagesIds=${messagesIds}`;
   return axios({
      method: "delete",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const moveEmailMessage = async (mailBoxId, messagesIds, moveFrom, moveTo) => {
   return await axios({
      method: "PUT",
      url: `${hostCloud}/email/message/move?mailBoxId=${mailBoxId}&messagesIds=${messagesIds}&moveFrom=${moveFrom}&moveTo=${moveTo}`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const deleteAllFromTrash = async (mailBoxId) => {
   return await axios({
      method: "DELETE",
      url: `${hostCloud}/email/message/trash/delete-all?mailBoxId=${mailBoxId}`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const getUserMailContacts = async () => {
   return await axios({
      method: "GET",
      url: `${hostCloud}/email/message/contacts`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const getMessageActions = async (instanceId) => {
   return await axios({
      method: "GET",
      url: `${hostCloud}/email/message/actions?instanceId=${instanceId}`,
      headers: {
         Accept: "*/*",
      },
   });
};
